module.exports = __webpack_public_path__ + "ionicons.c037dbbc0e6790f30e82.svg";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/ionicons.svg?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.svg?v=2.0.0
// module chunks = styles